import React from 'react'
import { ICONS } from '../../../themes'
import Numeral from 'numeral'

// Helpers
import {
  dateMonDayYearTimeFull,
  formatNumberWithCommaN2Decimal,
} from '../../../helpers'

// Components
import { Button, Image, Section, Table } from '../../../components'

// Constants
import BuyerHeader from '../constants/BuyerHeader'

const BidTable = ({
  leading,
  supplierRankingList,
  supplierBidHistory,
  toggleModal,
  currency,
  setItemBidClick,
}) => {
  const renderHeaderText = array => {
    return array.map((value, index) => {
      return (
        <Table.TH className={value.className} id={value.id} key={index}>
          {value.title.includes('AMOUNT')
            ? value.title + ` (${currency})`
            : value.title}
        </Table.TH>
      )
    })
  }

  const renderAuctionLeadingBid = () => {
    return (
      <>
        <Section className="bid-summary-title">
          <div className="title">Leading Bid:</div>
          <div className="detail">
            <b>
              {leading && formatNumberWithCommaN2Decimal(leading.price)}{' '}
              {currency}
            </b>
          </div>
        </Section>
        <Section className="bid-summary-list">
          <Section className="table-header-freeze-wrapper">
            <Table className="split-row-color">
              <Table.THEAD>
                <Table.TR className="header">
                  {renderHeaderText(BuyerHeader.BUYER_LEADING_BID_TITLE)}
                </Table.TR>
              </Table.THEAD>
              <Table.TBODY>
                <Section className="list">
                  {supplierRankingList.map((e, index) => (
                    <Table.TR key={index}>
                      <Table.TD className="summary-ranking-no">
                        {index + 1}
                      </Table.TD>
                      <Table.TD
                        className="summary-supplier-name"
                        title={e.company_name}
                      >
                        {e.company_name}
                      </Table.TD>
                      <Table.TD className="summary-bidding-amount">
                        {/* 2 decimal */}
                        {e.bid_total
                          ? Numeral(e.bid_total).format('0,0.00')
                          : '0.00'}
                      </Table.TD>
                      <Table.TD className="summary-bidding-time">
                        {e.log_time ? dateMonDayYearTimeFull(e.log_time) : '-'}
                      </Table.TD>
                      <Table.TD className="summary-no-of-bids">
                        {e.bid_no ? e.bid_no : 0}
                      </Table.TD>
                      <Table.TD className="summary-status">
                        {e.status ? (
                          <div className="status-online">Online</div>
                        ) : (
                          <div className="status-offline">Offline</div>
                        )}
                      </Table.TD>
                      <Table.TD className="summary-view-more center">
                        <Button
                          className="link"
                          onClick={() => {
                            toggleModal('modals-history-of-supplier')
                            setItemBidClick(e)
                          }}
                        >
                          <Image src={ICONS['icon-view.svg']} />
                        </Button>
                      </Table.TD>
                    </Table.TR>
                  ))}
                </Section>
              </Table.TBODY>
            </Table>
          </Section>
        </Section>
      </>
    )
  }

  const renderAuctionBidHistory = () => {
    return (
      <>
        <Section className="bid-history-title">
          <div className="title">BID HISTORY</div>
        </Section>
        <Section className="bid-history-list">
          <Section className="table-header-freeze-wrapper">
            <Table className="split-row-color">
              <Table.THEAD>
                <Table.TR className="header">
                  {renderHeaderText(BuyerHeader.BUYER_BIDDING_HISTORY_TITLE)}
                </Table.TR>
              </Table.THEAD>
              <Table.TBODY>
                <Section className="list">
                  {supplierBidHistory.map((e, index) => (
                    <Table.TR key={index}>
                      <Table.TD className="history-bidding-no">
                        {supplierBidHistory &&
                          supplierBidHistory.length - index}
                      </Table.TD>
                      <Table.TD className="history-supplier-name">
                        <Section className="cell-supplier-name">
                          {e.company_name || '-'}
                        </Section>
                      </Table.TD>
                      <Table.TD className="history-bidding-amount">
                        {/* 2 decimal */}
                        {e.total ? Numeral(e.total).format('0,0.00') : '0.00'}
                      </Table.TD>
                      <Table.TD className="history-bidding-time center">
                        {e.log_time ? dateMonDayYearTimeFull(e.log_time) : '-'}
                      </Table.TD>
                    </Table.TR>
                  ))}
                </Section>
              </Table.TBODY>
            </Table>
          </Section>
        </Section>
      </>
    )
  }

  return (
    <>
      {renderAuctionLeadingBid()}
      {renderAuctionBidHistory()}
    </>
  )
}

export default BidTable
